import { useContext } from 'react'
import { AppManagerContext } from '../contexts'

export function useAppManager () {
  return useContext(AppManagerContext)
}
